// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import dataTableStyles from "@sc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { accountMessagesStyles } from "@sc/Overrides/Widgets/MyAccount/AccountMessages";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

accountMessagesStyles.noMessagesGridItem = {
    width: 12,
};
accountMessagesStyles.noMessagesText = {
    ...dataTableStyles.noResultsText,
};

accountMessagesStyles.messageCard = {
    gridContainer: { gap: 0 },
    article: {
        css: css`
            width: 100%;
        `,
    },
    dateTimeGridItem: { width: 12 },
    dateTimeText: { weight: "bold", size: 14 },
    subjectGridItem: { width: 12 },
    subjectText: { size: 14 },
    bodyGridItem: { width: 12 },
    bodyText: { size: 14 },
    actionButtonGridItem: {
        width: 12,
        css: css`
            width: 140px;
            max-width: 170px;
            ${xScreen("lte", "sm")} {
                align-self: flex-end;
            }
        `,
    },
    actionButton: {
        variant: "secondary",
        css: css`
            margin-bottom: 10px;
        `,
    },
    bottomBorderGridItem: { width: 12 },
    bottomBorder: {
        css: css`
            height: 1px;
            width: 100%;
            background: ${color("common.border")};
        `,
    },
    contentWrapper: {
        width: 12,
        css: css`
            align-items: flex-end;
            padding-bottom: 8px;
            gap: 8px;
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
    },
    contentSection: {
        gap: 8,
    },
};

accountMessagesStyles.messagesGridContainer = {
    gap: 10,
};

accountMessagesStyles.messagesSection = {
    css: css`
        display: flex;
        flex: 1;
        padding: 12px;
    `,
};

accountMessagesStyles.messageFilter = {
    radioGroup: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: baseline;
        `,
    },
    radioButton: {
        css: css`
            max-height: 500px;
            overflow-y: auto;
            margin: 10px 20px 5px 0;
            &&& input {
                margin-left: 1px;
            }
        `,
    },
};

accountMessagesStyles.messagesAccordionSection = {
    panelProps: {
        css: css`
            max-height: 500px;
            overflow-y: auto;
            border-top: 1px solid ${color("common.border")};
        `,
    },
};
